<p-button (onClick)="showDialog = true">Dodaj jedinicu</p-button>

<ng-container *ngIf="showDialog">
  <p-dialog
    [resizable]="false"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '100vw', height: '100vh' }"
    appendTo="body"
  >
    <h2>Odaberite jedinice gradiva</h2>
    <app-select-jedinice-gradiva
      (itemSelected)="onSelectedItem($event)"
    ></app-select-jedinice-gradiva>
  </p-dialog>
</ng-container>
